export const THEME_STORAGE_KEY = 'efira-theme';
/**
 * Инлайн-скрипт для <head>. Без зависимостей, без модулей: он обязан
 * выполниться до того, как браузер покажет первый кадр.
 *
 * ДВА ПРИЗНАКА ТЕМЫ, ОДИН ИСТОЧНИК. `data-theme` читает наша разметка и сценарии, класс
 * `dark` - компоненты shadcn (их токены объявлены в `.dark`, а вариант
 * `dark:` собран как `&:is(.dark *)`). Учить одну из систем чужому признаку
 * значило бы править её на каждом обновлении; вместо этого скрипт темы
 * выставляет оба, и они не могут разойтись.
 */
export const THEME_BOOT_SCRIPT = "(function(){try{var t=localStorage.getItem('efira-theme');" +
    "if(t!=='light'&&t!=='dark'){t=matchMedia('(prefers-color-scheme: dark)').matches?'dark':'light'}" +
    "document.documentElement.setAttribute('data-theme',t);" +
    "document.documentElement.classList.toggle('dark',t==='dark')}catch(e){}})();";
//# sourceMappingURL=theme-boot.js.map